<div class="tw-flex tw-flex-col tw-gap-2.5 tw-p-4 tw-pb-3.5 tw-rounded-2xl tw-bg-white tw-border tw-border-solid tw-border-teal-200">
  <div class="tw-flex tw-gap-4">
    <div class="tw-flex-1 tw-flex tw-flex-col tw-gap-1">
      <p class="tw-font-lexend tw-font-bold tw-text-500 tw-leading-1.2 tw-text-black">{{ displayConcern() }}</p>
      <p class="tw-font-body tw-italic tw-text-400 tw-leading-1.2 tw-text-gray-500" i18n="@@getTreatmentPlanFromDoctorNow">Get a treatment plan from your doctor now</p>
    </div>
    @if (photo(); as checkup) {
      <app-ai-detection-canvas
        class="tw-block tw-flex-none tw-w-78 tw-h-22"
        [instantCheckup]="checkup"
        [excludeList]="excludeList"
        [mainConcern]="mainConcern()"></app-ai-detection-canvas>
    }
  </div>
  <div class="tw-flex tw-items-center tw-justify-center tw-gap-3 tw-w-full tw-py-2.5 tw-rounded-xl tw-bg-teal-600">
    @if (isHair()) {
      <span class="tw-font-lexend tw-font-bold tw-text-400 tw-text-white" i18n="@@completeHairTest">Complete Hair Test</span>
    } @else {
      <span class="tw-font-lexend tw-font-bold tw-text-400 tw-text-white" i18n="@@completeSkinTest">Complete Skin Test</span>
    }
    <img src="/assets/gifs/blinking-red-dot.gif" alt="red-blink-circle" class="tw-w-2 tw-h-2" />
  </div>
</div>
